import logo from './logo.svg';
import './App.css';
import React, { Component, Suspense, createRef, useState } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom';
import { CButton, CCard, CCardBody, CCardHeader, CCol, CFormInput, CModal, CModalBody, CRow } from '@coreui/react';
// import { ScreenCapture } from 'react-screen-capture';
import axios from 'axios';
import { ShowAlert } from './Common/Alert/Swal';
//import { useScreenshot } from 'use-react-screenshot';
import _nav from './Layout/_MainNav';
import { Resourse } from './Common/Resourses/Resourse';
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)
const Login = React.lazy(() => import('./Views/Login/Login'))
const DefaultLayout = React.lazy(() => import('./Layout/LayoutMain'))
function App() {
  const ref = createRef(null)
  // const [image, takeScreenshot] = useScreenshot()
  const [visible, setVisible] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')

  const getImage = () => {
    // takeScreenshot(ref.current)
    // setVisible(true)
  }
  const Submit = (downloadLink) => {
    if (errorMsg.length > 3) {
      if (downloadLink.match(/:(.*?);/) == null) {
        ShowAlert.ShowError('هیچ تصویری یافت نشد')
        setVisible(false)
      }
      else {
        var arr = downloadLink.split(','), mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        let data = {
          attachFile: new File([u8arr], 'file1', { type: mime })
        }
        let formData = null;
        formData = new FormData();
        formData.append('idUser', sessionStorage.getItem('IdUser'));
        formData.append('imgFile', data.attachFile);
        formData.append('fullName', sessionStorage.getItem('FullName'));
        formData.append('idMainCompany', sessionStorage.getItem('IdMainCompany'));
        formData.append('errorMsgUser', errorMsg);
        formData.append('pageEnName', sessionStorage.getItem('namePage'));
        formData.append('pagePerName', _nav.filter(q => q.to == sessionStorage.getItem('namePage')).length > 0 ? _nav.filter(q => q.to == sessionStorage.getItem('namePage'))[0].name : 'نام فارسی پیدا نشد');
        formData.append('imgName', 'خطا')
        const headers = { "Authorization": "Bearer " + sessionStorage.getItem("token") }
        const apiUrl = sessionStorage.getItem('URL');
        const result = axios.request({
          method: "post",
          url: `${apiUrl}/LogRecivedImgInsert`,
          data: formData,
          headers: headers,
        }).then(async result => {
          if (result.data.errorCode == 0) {
            await ShowAlert.ShowSuccess('عملیات با موفقیت انجام شد')
            setVisible(false)
            errorMsg = ''
          }
          else {
            await ShowAlert.ShowError(result.data.errorMsg)
          }
        }).catch(async result => {
          await ShowAlert.ShowError('بارگذاری با مشکل مواجه شده')
        })
      }
      // data = {
      //   ...data, attachFile: ticketFile, idMainTicket: Row.id, idUser: sessionStorage.getItem('IdUser'), filePath: data.attachFile, attachFileName: ticketFile ? ticketFile.name : null
      // }
      // const result = await MainTicketSrv.InsertMainTicketResponse(data);
      // if (result.data.errorCode != 1) {
      //   setRefreshList(RefreshList + 1)
      //   setVisible(false)
      // }
    }
    else
      ShowAlert.ShowError('متن خط وارد نشده است')
  };
  // changePrivateTxtFile = async (event) => {
  //   console.log('event')
  //   console.log(event)
  // }

  // render() {
  // const { screenCapture } = this.state.formData.screenCapture;
  return (
    // <ScreenCapture onEndCapture={this.handleScreenCapture}>
    // {({ onStartCapture }) => (
    <>
      {/* <button style={{ marginBottom: '10px', display: 'none' }} onClick={getImage} id='Capture'>
        Take screenshot
      </button> */}
      {/* <img width='50%' src={image} alt={'Screenshot'} /> */}
      {/* <button onClick={onStartCapture} style={{ display: 'none' }} id='Capture'></button>
            <div id='MainPage'>
            </div> */}
      <div ref={ref} dir='rtl'>
        <HashRouter>
          <Suspense fallback={loading} >
            <Routes>
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </HashRouter>
      </div>
      <CModal visible={visible} size='xl' onClose={e => setVisible(false)}>
        <CCard>
          <CCardHeader id='' className='mainPanel-header camera '> ارسال عکس خطا</CCardHeader>
          <CCardBody className='mainPanel-body camera ForInsUp'>
            {/* <CCard style={{ backgroundImage: 'this.state.screenCapture', minHeight: '400px', backgroundRepeat: 'no-repeat', backgroundPositionX: '50%', backgroundPositionY: '50%', padding: '18px' }}>
              <img src={image} alt='هیچ تصویری یافت نشد' />
            </CCard> */}
            <CRow className='BasePadding'>
              <CFormInput invalid={errorMsg.length > 3 ? false : true} feedbackInvalid={Resourse.InValidTxt + ' متن خطا حداقل سه کاراکتر است'} id='errorMsg' placeholder=' ' floatingLabel={'متن خطا'} onChange={e => setErrorMsg(e.target.value)}></CFormInput>
              <CCol xl={3} lg={5} md={7}>
                {/* <CButton type="submit" className="Save-button" id='Save-button' onClick={e => Submit(image)}>
                  ارسال
                  <span className="glyphicon SaveBtn"></span>
                </CButton> */}
                <CButton className='cancel-button' id='cancel-button' onClick={e => setVisible(false)}>
                  انصراف
                  <span className="glyphicon CancelBtn"></span>
                </CButton>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CModal>
    </>
    // )}
    // </ScreenCapture>
  )
};

// }
export default App;

